<section class="card bg-secondary border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
  <div class="card-header d-flex align-items-center justify-content-between">
    <h2 class="h4 mb-0"><i class="ai-note text-primary lead pe-1 me-2"></i>Noutati</h2>
    <a *ngIf="isEventOwner" (click)="onAddUpdatesClick(transactionBreakdownTemplate)"
      class="btn btn-sm btn-secondary "><i class="ai-edit ms-n1 me-2"></i>Adauga</a>
  </div>
  <div class="card-body">
    <ng-container *ngIf="updates">
      <div *ngFor="let x of updates; first as first" [ngClass]="first? 'pb-4': 'py-4'" class="border-bottom">
        <div [innerHTML]="x.description | safe: 'html'">
        </div>

        <div class="d-flex align-items-center pt-1 mt-n2">
          <i class="ai-time fs-lg me-2"></i>
          <span class="fs-sm text-muted">{{x.createdDate | date:'HH:mm dd/MM/yyyy'}}</span>
          <ng-container *ngIf="isEventOwner">
            <span class="fs-xs opacity-20 mx-3">|</span>
            <button (click)="onEditUpdateClick(x, transactionBreakdownTemplate)"
              class="nav-link fw-normal py-1 pe-0 ps-1 ms-2" type="button" aria-label="Modifica"
              ngbTooltip="Modifica"><i class="ai-edit-alt"></i></button>
            <button (click)="onDeleteUpdateClick(x.id)" class="nav-link text-danger fw-normal py-1 pe-0 ps-1 ms-3"
              type="button" aria-label="Sterge" ngbTooltip="Sterge"><i class="ai-trash"></i></button>
          </ng-container>
        </div>

      </div>
    </ng-container>

    <!-- Loading template -->
    <div *ngIf="!updates">
      <div *ngFor="let item of [].constructor(2); first as first" [ngClass]="first? 'pb-4': 'py-4'"
        class="border-bottom placeholder-glow" aria-hidden="true">
        <span class="placeholder placeholder-sm col-7 me-2"></span>
        <span class="placeholder placeholder-sm col-4"></span>
        <span class="placeholder placeholder-sm col-8"></span>
        <span class="placeholder placeholder-sm col-4 me-2"></span>
        <span class="placeholder placeholder-sm col-6"></span>
      </div>
    </div>
  </div>
</section>


<!--Add/Update content -->
<ng-template #transactionBreakdownTemplate let-modal>
  <div class="modal-header border-0">
    <h4 class="modal-title">Adauga noutate</h4>
    <button (click)="modal?.dismiss()" class="btn-close" type="button" aria-label="Close"></button>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="pt-0" autocomplete="off" novalidate>
    <div class="modal-body">
      <div class="row row-cols-1 g-4">
        <div class="col">
          <label class="form-label" for="message">Continut</label>
          <editor formControlName="description" [init]="{
                base_url: '/tinymce',
                suffix: '.min',
                height: 300,
                menubar: false,
                statusbar: false,
                automatic_uploads: false,
                paste_data_images: true,
                theme: 'silver',
                style_formats: styleFormats,
                plugins:
                'advlist autolink lists link image charmap preview anchor \
                searchreplace visualblocks code fullscreen \
                insertdatetime media table',
                toolbar:
                  'undo redo | \
                  bold italic underline forecolor backcolor | \
                  styles | \
                  bullist numlist outdent indent | \
                  link image'
                }" licenseKey="gpl" [ngClass]="{'is-invalid': vs.hasErrors(form, 'description')}"></editor>
          <div *ngIf="vs.hasErrors(form, 'description')" class="invalid-feedback">{{vs.getError(form,
            'description')}}</div>
        </div>

      </div>
    </div>
    <div class="modal-footer border-0">
      <button (click)="modal?.close()" class="btn btn-secondary w-100 w-sm-auto mb-3 mb-sm-0"
        type="button">Anuleaza</button>
      <button class="btn btn-primary w-100 w-sm-auto ms-sm-3" type="submit">Adauga</button>
    </div>
  </form>
</ng-template>
